import { atom } from 'jotai';

export const isEditDatesAtom = atom<boolean>(false);
export const isEditTravelersAtom = atom<boolean>(false);
